import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface accountCategoryMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAccountCategoryList: any[];
}

const initialState: accountCategoryMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allAccountCategoryList: [],
};

export const accountCategoryMasterSlice = createSlice({
  name: 'accountCategoryMaster',
  initialState,
  reducers: {
    setAccountCategoryMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAccountCategoryBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAccountCategoryMaster: (state, action) => {
      state.allAccountCategoryList = action.payload.data;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setAccountCategoryMaster, setAccountCategoryBySearch, reset, setAllAccountCategoryMaster } = accountCategoryMasterSlice.actions;
export const getAccountCategoryMasterDetails = (state: RootState) => state.accountCategoryMaster.data;
export const getAccountCategoryDetailsBySearch = (state: RootState) => state.accountCategoryMaster.data;
export const getAccountCategoryMasterTotalRecords = (state: RootState) => state.accountCategoryMaster.totalRecords;
export const getAllAccountCategoryMasterList = (state: RootState) => state.accountCategoryMaster.allAccountCategoryList;
export const getAccountCategoryMasterListWithAll = (state: RootState) => [
  {
    id: 0,
    accountCategoryName: "ALL",
    description: "All Categories",
    isActive: true,
  },
  ...(state.accountCategoryMaster.allAccountCategoryList || []),
];
export default accountCategoryMasterSlice.reducer;